export default __webpack_public_path__ + "static/cointelegraph-4edd5dc2fec2acc77b1f29a79ad4c1a9.svg";